import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import ImagePicker from "../../components/ui/imagePicker";
import { useEffect, useMemo, useState } from "react";
import Resizer from "react-image-file-resizer";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db, storage } from "src/firebase/firebase";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import { getAdmin, getATMCardDetail, getCards } from "src/firebase/admin.js";
import Loader from "../../components/loader";
import Checkbox from "../../components/checkbox/checkbox";
import axios from "axios";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required.")
    .typeError("Accept only string"),
});
const initialValues = {
  name: "",
};
const AddPriceGroup = ({ setShowRate }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const { t } = useTranslation(["home"]);
  const location = useLocation();
  const navigate = useNavigate();
  const [initValue, setInitValue] = useState(initialValues);
  const id = new URLSearchParams(location.search).get("id");

  const handleAddCard = async (cardValue) => {
    let values: any = {
      ...cardValue,
    };
    values.id = uuidv4();

    setIsLoading(true);

    const q = await query(
      collection(db, "PriceGroup"),
      where("name", "==", values.name)
    );
    const querySnapshot = await getDocs(q);
    const data = querySnapshot.docs.map((item) => item.data());

    if (data.length > 0) {
      setIsLoading(false);
      handleToastMessage("error", "Duplicate price group name");
      return;
    }

    await setDoc(doc(db, "PriceGroup", values.id), values);
    handleToastMessage("success", "Price group added successfully");
    setInitValue({ ...initialValues });
    setShowRate(false);
  };

  return (
    <div className="p-3">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Add price group")}
        </h2>
      </div>
      <div className="pb-4 bg-white">
        <div>
          {Object.keys(initValue).length > 0 && (
            <Formik
              enableReinitialize
              initialValues={initValue}
              validationSchema={validationSchema}
              onSubmit={handleAddCard}
              validateOnBlur
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                handleBlur,
                handleChange,
                isSubmitting,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="flex gap-3 mb-2">
                      <Input
                        label="Price group name"
                        containerClass="w-full"
                        placeholder="Price group name"
                        name="name"
                        className="flex-1"
                        error={errors.name}
                        touched={touched.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        variant="solid"
                      />
                    </div>

                    <div className="flex justify-end">
                      <Button
                        size="small"
                        className="ml-0 block bg-blue mt-4 mb-3"
                        loading={isLoading}
                        type="button"
                        onClick={handleSubmit as any}
                      >
                        {t("Add")}
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>
    </div>
  );
};
export default AddPriceGroup;
